import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { darkTheme, lightTheme } from '../../settings/appStyle/theme';
import { GlobalStyles } from '../../settings/appStyle/global.style';
import PolicyPage from './pages/Policypage';
import TermsPage from './pages/Termspage';
import LandingPage from './pages/Landing';

export default function LandingContainer() {
  const location = useLocation();
  const [isDark, setIsDark] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      return savedTheme === 'dark';
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
    document.documentElement.classList.toggle('dark', isDark);
  }, [isDark]);

  const toggleTheme = () => {
    setIsDark(!isDark);
  };

  const renderPage = () => {
    switch (location.pathname) {
      case '/policy':
        return <PolicyPage isDark={isDark} toggleTheme={toggleTheme} />;
      case '/terms':
        return <TermsPage isDark={isDark} toggleTheme={toggleTheme} />;
      default:
        return <LandingPage isDark={isDark} toggleTheme={toggleTheme} />;
    }
  };

  return (
    <ThemeProvider theme={isDark ? darkTheme : lightTheme}>
      <GlobalStyles />
      {renderPage()}
    </ThemeProvider>
  );
}
